import { performRequest } from "../performRequest";


export const getJobListApi = (params) => {
    return performRequest("get", "api/ess/job/",params)
}

export const getJobDetailApi = (id, params) => {
    return performRequest("get", `api/ess/job/${id}/`, params);
}

export const createJobApi = (params) => {
    const company = localStorage.getItem('company') || 1

    params['company'] = company
    return performRequest("post", "api/ess/job/",params)
}

export const updateJobApi = (params, id) => {
    const company = localStorage.getItem('company') || 1

    params['company'] = company
    return performRequest("put", `api/ess/job/${id}/`,params)
}


export const getJobListPublicApi = (params) => {
    return performRequest("get", "api/ess/job/list/",params, false)
}


export const getJobDetailPublicApi = (slug, params) => {
    return performRequest("get", `/api/public/jobs/${slug}/`,params, false)
}


export const applyJobPublicApi = ( data) => {
    return performRequest("post", `/api/public/jobs/${data.job}/apply/`,data, false)
}

// Email verification API functions
export const sendEmailVerificationOTP = (data) => {
  return performRequest("post", "/api/public/email-verification/send-otp/", data, false);
};

export const verifyEmailOTP = (data) => {
  return performRequest("post", "/api/public/email-verification/verify-otp/", data, false);
};

export const resendEmailVerificationOTP = (data) => {
  return performRequest("post", "/api/public/email-verification/resend-otp/", data, false);
};


export const applyJobInternalApi = ( data) => {
  return performRequest("post", `/api/public/jobs/${data.job}/apply/`,data)
}

// Job Drive API functions
export const getJobDriveSlotsApi = (params) => {
  const company = localStorage.getItem('company') || 1;
  return performRequest("get", `api/ess/job-drive/slots/`, { company, ...params });
};

export const getJobDriveSlotDetailApi = (slotId, params) => {
  const company = localStorage.getItem('company') || 1;
  return performRequest("get", `api/ess/job-drive/slots/${slotId}/`, { company, ...params });
};

export const createJobDriveSlotApi = (data) => {
  const company = localStorage.getItem('company') || 1;
  return performRequest("post", `api/ess/job-drive/slots/`, { company, ...data });
};

export const updateJobDriveSlotApi = (slotId, data) => {
  const company = localStorage.getItem('company') || 1;
  return performRequest("patch", `api/ess/job-drive/slots/${slotId}/`, { company, ...data });
};

export const deleteJobDriveSlotApi = (slotId) => {
  const company = localStorage.getItem('company') || 1;
  return performRequest("delete", `api/ess/job-drive/slots/${slotId}/`, { company });
};

export const getJobDriveInvitationsApi = (params) => {
  const company = localStorage.getItem('company') || 1;
  return performRequest("get", `api/ess/job-drive/invitations/`, { company, ...params });
};

export const getJobDriveInvitationDetailApi = (invitationId, params) => {
  const company = localStorage.getItem('company') || 1;
  return performRequest("get", `api/ess/job-drive/invitations/${invitationId}/`, { company, ...params });
};

export const assignSlotToApplicantsApi = (applicantIds, slotId) => {
  const company = localStorage.getItem('company') || 1;
  return performRequest("post", `api/ess/job-drive/invitations/assign-slot/`, { 
    company,
    applicant_ids: applicantIds,
    slot_id: slotId
  });
};

export const sendJobDriveInvitationsApi = (applicantIds, slotId) => {
  const company = localStorage.getItem('company') || 1;
  return performRequest("post", `api/ess/job-drive/invitations/send-invitation/`, {
    company,
    applicant_ids: applicantIds,
    slot_id: slotId
  });
};

export const verifyQRTokenApi = (token) => {
  const company = localStorage.getItem('company') || 1;
  return performRequest("post", `api/ess/job-drive/scanner/verify/`, { company, token });
};

export const checkInQRTokenApi = (token) => {
  const company = localStorage.getItem('company') || 1;
  return performRequest("post", `api/ess/job-drive/scanner/check-in/`, { company, token });
};

export const getJobDriveDashboardApi = (jobId, params) => {
  const company = localStorage.getItem('company') || 1;
  return performRequest("get", `api/ess/job-drive/dashboard/`, { company, job_id: jobId, ...params });
};

export const getJobDriveAttendanceApi = (params) => {
  const company = localStorage.getItem('company') || 1;
  return performRequest("get", `api/ess/job-drive/attendance/`, { company, ...params });
};